import React, {useState} from 'react';
import {StandardLayout} from "../layout/StandardLayout";
import * as d3 from 'd3';
import {Button} from "../components/Button";

export const useD3 = (renderChartFn, dependencies) => {
    const ref = React.useRef();

    React.useEffect(() => {
        renderChartFn(d3.select(ref.current));
        return () => {
        };
    }, dependencies);
    return ref;
}



export function FanChartShowcasePage(props) {


    const [myRpm, setMyRpm] = useState(125);
    const [myDiameter, setMyDiameter] = useState(2771);

    const flowLines = [
        {
            "bladeAngle": 2.8,
            "flows": [0.077625, 0.07885400406107647, 0.08008300812215295, 0.08131201218322943, 0.0825410162443059, 0.08377002030538239, 0.08499902436645887, 0.08622802842753534, 0.08745703248861182, 0.0886860365496883, 0.08991504061076477, 0.09114404467184126, 0.09237304873291774, 0.09360205279399421, 0.09483105685507069, 0.09606006091614716, 0.09728906497722364, 0.09851806903830013, 0.0997470730993766, 0.10097607716045308, 0.10220508122152956, 0.10343408528260603, 0.10466308934368251, 0.105892093404759, 0.10712109746583547, 0.10835010152691195, 0.10957910558798842, 0.1108081096490649, 0.11203711371014138, 0.11326611777121785, 0.11449512183229434, 0.11572412589337082, 0.11695312995444729, 0.11818213401552377, 0.11941113807660025, 0.12064014213767672, 0.1218691461987532, 0.12309815025982968, 0.12432715432090616, 0.12555615838198264, 0.12678516244305912, 0.1280141665041356, 0.12924317056521206, 0.13047217462628855, 0.131701178687365, 0.13293018274844148, 0.13415918680951797, 0.13538819087059445, 0.13661719493167093, 0.13784619899274742, 0.13907520305382387, 0.14030420711490035, 0.14153321117597684, 0.14276221523705332, 0.1439912192981298, 0.14522022335920626, 0.14644922742028274, 0.14767823148135922, 0.1489072355424357, 0.1501362396035122, 0.15136524366458867, 0.15259424772566513, 0.1538232517867416, 0.1550522558478181, 0.15628125990889458, 0.15751026396997106, 0.15873926803104754, 0.159968272092124, 0.16119727615320048, 0.16242628021427696, 0.16365528427535345, 0.16488428833642993, 0.16611329239750638, 0.16734229645858287, 0.16857130051965935, 0.16980030458073583, 0.17102930864181232, 0.1722583127028888, 0.17348731676396525, 0.17471632082504174, 0.17594532488611822, 0.1771743289471947, 0.1784033330082712, 0.17963233706934764, 0.18086134113042412, 0.1820903451915006, 0.1833193492525771, 0.18454835331365357, 0.18577735737473006, 0.1870063614358065, 0.188235365496883, 0.18946436955795948, 0.19069337361903596, 0.19192237768011244, 0.1931513817411889, 0.19438038580226538, 0.19560938986334186, 0.19683839392441835, 0.19806739798549483, 0.1992964020465713, 0.20052540610764777, 0.20175441016872425, 0.20298341422980073, 0.20421241829087722, 0.2054414223519537, 0.20667042641303016, 0.20789943047410664, 0.20912843453518312, 0.2103574385962596, 0.2115864426573361, 0.21281544671841257, 0.21404445077948903, 0.2152734548405655, 0.216502458901642, 0.21773146296271847, 0.21896046702379496, 0.22018947108487144, 0.2214184751459479, 0.22264747920702438, 0.22387648326810086, 0.22510548732917735, 0.22633449139025383, 0.22756349545133028, 0.22879249951240677, 0.23002150357348325, 0.23125050763455973, 0.23247951169563622, 0.2337085157567127, 0.23493751981778915, 0.23616652387886564, 0.23739552793994212, 0.2386245320010186, 0.23985353606209509, 0.24108254012317154, 0.24231154418424802, 0.2435405482453245, 0.244769552306401, 0.24599855636747747, 0.24722756042855396, 0.2484565644896304, 0.2496855685507069, 0.2509145726117834, 0.25214357667285986, 0.2533725807339363, 0.2546015847950128, 0.2558305888560893, 0.2570595929171658, 0.25828859697824225, 0.2595176010393187, 0.26074660510039516, 0.26197560916147167, 0.2632046132225481, 0.2644336172836246, 0.2656626213447011, 0.26689162540577754, 0.26812062946685405, 0.2693496335279305, 0.270578637589007, 0.2718076416500835, 0.27303664571115993, 0.27426564977223644, 0.2754946538333129, 0.2767236578943894, 0.27795266195546586, 0.2791816660165423, 0.28041067007761883, 0.2816396741386953, 0.2828686781997718, 0.28409768226084825, 0.2853266863219247, 0.2865556903830012, 0.28778469444407767, 0.2890136985051542, 0.29024270256623064, 0.29147170662730715, 0.2927007106883836, 0.29392971474946006, 0.29515871881053657, 0.296387722871613, 0.29761672693268953, 0.298845730993766, 0.30007473505484245, 0.30130373911591896, 0.3025327431769954, 0.3037617472380719, 0.3049907512991484, 0.30621975536022483, 0.30744875942130134, 0.3086777634823778, 0.3099067675434543, 0.31113577160453076, 0.3123647756656072, 0.31359377972668373, 0.3148227837877602, 0.3160517878488367, 0.31728079190991315, 0.31850979597098966, 0.3197388000320661, 0.3209678040931426, 0.3221968081542191, 0.32342581221529554, 0.32465481627637205, 0.3258838203374485, 0.32711282439852496, 0.32834182845960147, 0.3295708325206779, 0.33079983658175444, 0.3320288406428309, 0.33325784470390735, 0.33448684876498386, 0.3357158528260603, 0.3369448568871368, 0.3381738609482133, 0.3394028650092898, 0.34063186907036624, 0.3418608731314427, 0.3430898771925192, 0.34431888125359567, 0.3455478853146722, 0.34677688937574863, 0.3480058934368251, 0.3492348974979016, 0.35046390155897805, 0.35169290562005456, 0.352921909681131, 0.3541509137422075, 0.355379917803284, 0.35660892186436044, 0.35783792592543695, 0.3590669299865134, 0.36029593404758986, 0.36152493810866637, 0.3627539421697428, 0.36398294623081934, 0.3652119502918958, 0.3664409543529723, 0.36766995841404876, 0.3688989624751252, 0.3701279665362017, 0.3713569705972782],
            "pressures": [-1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0]
        },
        {
            "bladeAngle": 6.0,
            "flows": [0.077625, 0.07885400406107647, 0.08008300812215295, 0.08131201218322943, 0.0825410162443059, 0.08377002030538239, 0.08499902436645887, 0.08622802842753534, 0.08745703248861182, 0.0886860365496883, 0.08991504061076477, 0.09114404467184126, 0.09237304873291774, 0.09360205279399421, 0.09483105685507069, 0.09606006091614716, 0.09728906497722364, 0.09851806903830013, 0.0997470730993766, 0.10097607716045308, 0.10220508122152956, 0.10343408528260603, 0.10466308934368251, 0.105892093404759, 0.10712109746583547, 0.10835010152691195, 0.10957910558798842, 0.1108081096490649, 0.11203711371014138, 0.11326611777121785, 0.11449512183229434, 0.11572412589337082, 0.11695312995444729, 0.11818213401552377, 0.11941113807660025, 0.12064014213767672, 0.1218691461987532, 0.12309815025982968, 0.12432715432090616, 0.12555615838198264, 0.12678516244305912, 0.1280141665041356, 0.12924317056521206, 0.13047217462628855, 0.131701178687365, 0.13293018274844148, 0.13415918680951797, 0.13538819087059445, 0.13661719493167093, 0.13784619899274742, 0.13907520305382387, 0.14030420711490035, 0.14153321117597684, 0.14276221523705332, 0.1439912192981298, 0.14522022335920626, 0.14644922742028274, 0.14767823148135922, 0.1489072355424357, 0.1501362396035122, 0.15136524366458867, 0.15259424772566513, 0.1538232517867416, 0.1550522558478181, 0.15628125990889458, 0.15751026396997106, 0.15873926803104754, 0.159968272092124, 0.16119727615320048, 0.16242628021427696, 0.16365528427535345, 0.16488428833642993, 0.16611329239750638, 0.16734229645858287, 0.16857130051965935, 0.16980030458073583, 0.17102930864181232, 0.1722583127028888, 0.17348731676396525, 0.17471632082504174, 0.17594532488611822, 0.1771743289471947, 0.1784033330082712, 0.17963233706934764, 0.18086134113042412, 0.1820903451915006, 0.1833193492525771, 0.18454835331365357, 0.18577735737473006, 0.1870063614358065, 0.188235365496883, 0.18946436955795948, 0.19069337361903596, 0.19192237768011244, 0.1931513817411889, 0.19438038580226538, 0.19560938986334186, 0.19683839392441835, 0.19806739798549483, 0.1992964020465713, 0.20052540610764777, 0.20175441016872425, 0.20298341422980073, 0.20421241829087722, 0.2054414223519537, 0.20667042641303016, 0.20789943047410664, 0.20912843453518312, 0.2103574385962596, 0.2115864426573361, 0.21281544671841257, 0.21404445077948903, 0.2152734548405655, 0.216502458901642, 0.21773146296271847, 0.21896046702379496, 0.22018947108487144, 0.2214184751459479, 0.22264747920702438, 0.22387648326810086, 0.22510548732917735, 0.22633449139025383, 0.22756349545133028, 0.22879249951240677, 0.23002150357348325, 0.23125050763455973, 0.23247951169563622, 0.2337085157567127, 0.23493751981778915, 0.23616652387886564, 0.23739552793994212, 0.2386245320010186, 0.23985353606209509, 0.24108254012317154, 0.24231154418424802, 0.2435405482453245, 0.244769552306401, 0.24599855636747747, 0.24722756042855396, 0.2484565644896304, 0.2496855685507069, 0.2509145726117834, 0.25214357667285986, 0.2533725807339363, 0.2546015847950128, 0.2558305888560893, 0.2570595929171658, 0.25828859697824225, 0.2595176010393187, 0.26074660510039516, 0.26197560916147167, 0.2632046132225481, 0.2644336172836246, 0.2656626213447011, 0.26689162540577754, 0.26812062946685405, 0.2693496335279305, 0.270578637589007, 0.2718076416500835, 0.27303664571115993, 0.27426564977223644, 0.2754946538333129, 0.2767236578943894, 0.27795266195546586, 0.2791816660165423, 0.28041067007761883, 0.2816396741386953, 0.2828686781997718, 0.28409768226084825, 0.2853266863219247, 0.2865556903830012, 0.28778469444407767, 0.2890136985051542, 0.29024270256623064, 0.29147170662730715, 0.2927007106883836, 0.29392971474946006, 0.29515871881053657, 0.296387722871613, 0.29761672693268953, 0.298845730993766, 0.30007473505484245, 0.30130373911591896, 0.3025327431769954, 0.3037617472380719, 0.3049907512991484, 0.30621975536022483, 0.30744875942130134, 0.3086777634823778, 0.3099067675434543, 0.31113577160453076, 0.3123647756656072, 0.31359377972668373, 0.3148227837877602, 0.3160517878488367, 0.31728079190991315, 0.31850979597098966, 0.3197388000320661, 0.3209678040931426, 0.3221968081542191, 0.32342581221529554, 0.32465481627637205, 0.3258838203374485, 0.32711282439852496, 0.32834182845960147, 0.3295708325206779, 0.33079983658175444, 0.3320288406428309, 0.33325784470390735, 0.33448684876498386, 0.3357158528260603, 0.3369448568871368, 0.3381738609482133, 0.3394028650092898, 0.34063186907036624, 0.3418608731314427, 0.3430898771925192, 0.34431888125359567, 0.3455478853146722, 0.34677688937574863, 0.3480058934368251, 0.3492348974979016, 0.35046390155897805, 0.35169290562005456, 0.352921909681131, 0.3541509137422075, 0.355379917803284, 0.35660892186436044, 0.35783792592543695, 0.3590669299865134, 0.36029593404758986, 0.36152493810866637, 0.3627539421697428, 0.36398294623081934, 0.3652119502918958, 0.3664409543529723, 0.36766995841404876, 0.3688989624751252, 0.3701279665362017, 0.3713569705972782],
            "pressures": [0.11164415, 0.10954520000000001, 0.1075462, 0.10564715000000001, 0.10384805000000001, 0.10204895, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0, -1.0]
        },
        {
            "bladeAngle": 11.1,
            "flows": [
                0.06642455814951638,
                0.06769749039144994,
                0.0689704226333835,
                0.07024335487531705,
                0.07151628711725061,
                0.07278921935918417,
                0.07406215160111773,
                0.07533508384305129,
                0.07660801608498485,
                0.07788094832691841,
                0.07915388056885196,
                0.08042681281078552,
                0.08169974505271908,
                0.08297267729465264,
                0.0842456095365862,
                0.08551854177851975,
                0.08679147402045331,
                0.08806440626238687,
                0.08933733850432043,
                0.090610270746254,
                0.09188320298818756,
                0.09315613523012112,
                0.09442906747205468,
                0.09570199971398823,
                0.09697493195592179,
                0.09824786419785535,
                0.09952079643978891,
                0.10079372868172246,
                0.10206666092365602,
                0.10333959316558958,
                0.10461252540752314,
                0.1058854576494567,
                0.10715838989139026,
                0.10843132213332382,
                0.10970425437525738,
                0.11097718661719094,
                0.1122501188591245,
                0.11352305110105806,
                0.11479598334299163,
                0.11606891558492517,
                0.11734184782685873,
                0.1186147800687923,
                0.11988771231072584,
                0.1211606445526594,
                0.12243357679459296,
                0.12370650903652652,
                0.12497944127846008,
                0.12625237352039365,
                0.1275253057623272,
                0.12879823800426077,
                0.1300711702461943,
                0.1313441024881279,
                0.13261703473006142,
                0.133889966971995,
                0.13516289921392854,
                0.1364358314558621,
                0.13770876369779567,
                0.13898169593972923,
                0.1402546281816628,
                0.14152756042359635,
                0.1428004926655299,
                0.14407342490746347,
                0.14534635714939703,
                0.14661928939133057,
                0.14789222163326415,
                0.1491651538751977,
                0.15043808611713128,
                0.1517110183590648,
                0.1529839506009984,
                0.15425688284293193,
                0.1555298150848655,
                0.15680274732679905,
                0.1580756795687326,
                0.15934861181066617,
                0.16062154405259974,
                0.1618944762945333,
                0.16316740853646686,
                0.16444034077840042,
                0.16571327302033395,
                0.16698620526226754,
                0.16825913750420107,
                0.16953206974613466,
                0.1708050019880682,
                0.17207793423000178,
                0.17335086647193532,
                0.17462379871386888,
                0.17589673095580244,
                0.177169663197736,
                0.17844259543966956,
                0.17971552768160312,
                0.18098845992353668,
                0.18226139216547024,
                0.1835343244074038,
                0.18480725664933734,
                0.18608018889127093,
                0.18735312113320446,
                0.18862605337513802,
                0.18989898561707158,
                0.1911719178590051,
                0.1924448501009387,
                0.19371778234287224,
                0.19499071458480582,
                0.19626364682673936,
                0.19753657906867295,
                0.19880951131060648,
                0.20008244355254007,
                0.2013553757944736,
                0.2026283080364072
            ],
            "pressures": [
                0.22859864925472162,
                0.22504751687136137,
                0.22163092250262062,
                0.2183440685130279,
                0.2151822247774633,
                0.2121407286811624,
                0.2092149851197126,
                0.2064004664990563,
                0.20369271273548784,
                0.2010873312556568,
                0.1985799969965646,
                0.19616645240556752,
                0.19384250744037423,
                0.19160403956904792,
                0.1894469937700045,
                0.18736738253201357,
                0.18536128585419887,
                0.18342485124603658,
                0.18155429372735754,
                0.17974589582834488,
                0.1779960075895365,
                0.17630104656182233,
                0.17465749780644746,
                0.17306191389500958,
                0.1715109149094597,
                0.17000118844210266,
                0.16852948959559655,
                0.16709264098295407,
                0.16568753272753967,
                0.16431112246307245,
                0.1629604353336246,
                0.16163256399362214,
                0.16032466860784467,
                0.15903397685142495,
                0.15775778390984907,
                0.15649345247895707,
                0.15523841276494232,
                0.15399016248435193,
                0.1527462668640861,
                0.151504358641399,
                0.15026213806389743,
                0.14901737288954264,
                0.14776789838664983,
                0.14651161733388574,
                0.14524650002027284,
                0.14397058424518516,
                0.14268197531835203,
                0.14137884605985473,
                0.14005943680012967,
                0.13872205537996407,
                0.1373650771505034,
                0.13598694497323993,
                0.13458616922002686,
                0.13316132777306466,
                0.13171106602491112,
                0.1302340968784751,
                0.12872920074702188,
                0.12719522555416696,
                0.12563108673388224,
                0.12403576723049003,
                0.12240831749866976,
                0.12074785550345146,
                0.11905356672021983,
                0.11732470413471419,
                0.11556058824302406,
                0.11376060705159585,
                0.11192421607722769,
                0.1100509383470728,
                0.10814036439863595,
                0.1061921522797763,
                0.10420602754870611,
                0.10218178327399319,
                0.10011928003455417,
                0.09801844591966635,
                0.09587927652895234,
                0.09370183497239648,
                0.09148625187032844,
                0.08923272535343785,
                0.08694152106276498,
                0.08461297214970342,
                0.08224747927600184,
                0.07984551061376133,
                0.07740760184543494,
                0.07493435616383437,
                0.0724264442721193,
                0.06988460438380406,
                0.06730964222275893,
                0.06470243102320661,
                0.062063911529720905,
                0.059395091997232474,
                0.05669704819102439,
                0.05397092338673437,
                0.05121792837034633,
                0.04843934143821127,
                0.045636508397021935,
                0.042810842563830165,
                0.03996382476603666,
                0.03709700334140298,
                0.03421199413803688,
                0.03131048051440477,
                0.02839421333932457,
                0.02546501099196752,
                0.022524759361856383,
                0.019575411848870794,
                0.016618989363245018,
                0.013657580325561303,
                0.010693340666761864,
                0.007728493828133343
            ]
        }
    ];


    const housingDiameter = 3000;
    const impellerDiameter = housingDiameter * 1;
    const rpm = 125;

    //const housingArea_A2 = Math.PI * (housingDiameter / 1000) * (housingDiameter / 1000) / 4;

    let referenceFlows = [];
    let referencePressures = [];
    let bladeEndSpeed = 3.14 * (impellerDiameter / 1000) * rpm / 60;
    let maxFlow = 0;
    let maxPressure = 0;
    console.log("Blade end speed ", bladeEndSpeed);
    for (let i = 0; i < flowLines[2].flows.length; i++) {
        referenceFlows[i] = flowLines[2].flows[i] * (3.14 * (housingDiameter / 1000) * (housingDiameter / 1000) * bladeEndSpeed) / 4;
        referencePressures[i] = flowLines[2].pressures[i] * (1.25 * bladeEndSpeed * bladeEndSpeed) /2 ;
        // console.log(referenceFlows[i] + " m3/s " + referencePressures[i] + "Pa");
        if (referenceFlows[i] > maxFlow) {
            maxFlow = referenceFlows[i];
        }
        if (referencePressures[i] > maxPressure) {
            maxPressure = referencePressures[i];
        }
    }

    const my_housingDiameter = myDiameter;
    const my_impellerDiameter = my_housingDiameter * 1;
    const my_rpm = myRpm;
    let my_referenceFlows = [];
    let my_referencePressures = [];
    let my_bladeEndSpeed = Math.PI * (my_impellerDiameter / 1000) * my_rpm / 60;
    for (let i = 0; i < flowLines[2].flows.length; i++) {
        my_referenceFlows[i] = flowLines[2].flows[i] * (Math.PI * (my_housingDiameter / 1000) * (my_housingDiameter / 1000) * my_bladeEndSpeed) / 4;
        my_referencePressures[i] = flowLines[2].pressures[i] * (1.25 * my_bladeEndSpeed * my_bladeEndSpeed) / 2;

    }
    console.log("RERENDER", Math.random());


    console.log("ENTRY" + flowLines[2].flows[70] + " ---- " + flowLines[2].pressures[70]);
    // ENTRY 0.188235365496883 ---- 0.0287352
    // ENTRY 0.16365528427535345 ---- 0.10197005

    //D^2 = (60*4*Q)*sqrt(Psi0*1.25*3.14*3.14)   /  (60 * sqrt(P) * Fi0*3.14*3.14 )


    const requestedQ = 8.0;
    const requestedPtot = 88;

//    const guessD = Math.sqrt(4*requestedQ / ( 0.188235365496883 * 3.14*Math.sqrt( requestedPtot/(0.0287352*1.25) ) ));

    const guessD = 1000 * 2 * Math.sqrt(requestedQ) / Math.sqrt(0.07278921935918417 * Math.PI * Math.sqrt(requestedPtot / (0.212140728681162 * 1.25)));
    console.log("GUESS D: " + guessD);

    const guessRpm = Math.sqrt(requestedPtot / (0.212140728681162 * 1.25)) * 60 * 1000 / (Math.PI * guessD);
    console.log("GUESS RPM: " + guessRpm);


    const ref = useD3(
        (svg) => {

            const width = 1000;
            const height = 600;

            const minFlowValue = 0; // todo calculate
            const maxFlowValue = maxFlow * 1.3; // todo calculate
            const minPressureValue = 0;
            const maxPressureValue = maxPressure * 2.3;

            const chartDataAreaWidth = width; // todo calculate
            const chartDataAreaHeight = height; // todo calculate

            // if ( was =-= true) {
            //     return;
            // }
            // was = true;


            const d3RootG = svg.append("g").attr("class", "rootg");//.attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            const d3ScaleX = d3.scaleLinear().range([0, chartDataAreaWidth]).domain([minFlowValue, maxFlowValue]);
            d3RootG.append("g")
                .attr("class", "axis axis--x")
                .attr("transform", "translate(0," + height + ")")
                .call(d3.axisBottom(d3ScaleX).ticks(15))
                .selectAll("text").attr("y", -5).attr("x", 7)
                //.attr("dy", ".35em")
                .attr("transform", "rotate(90)")
                .style("text-anchor", "start");

            const d3ScaleY = d3.scaleLinear().range([chartDataAreaHeight, 0]).domain([minPressureValue, maxPressureValue]);
            d3RootG.append("g")
                //.attr("class", "axis axis--y")
                //.attr("transform", "translate(0," + height + ")")
                .call(d3.axisLeft(d3ScaleY).ticks(15));

            const lineFunc = d3.line()
                .x(function (domainPoint) {
                    return d3ScaleX(domainPoint.f)
                })
                .y(function (domainPoint) {
                    return d3ScaleY(domainPoint.p)
                });

            let points = [];
            for (let i = 0; i < flowLines[2].flows.length; i++) {
                if (referencePressures[i] > 0) {
                    points.push({f: referenceFlows[i], p: referencePressures[i]});
                }
            }
            console.log("points", points);
            d3RootG.append("path")
                .attr("class", "sound-level-line")
                .attr("d", lineFunc(points));

            let points2 = [];
            for (let i = 0; i < flowLines[2].flows.length; i++) {
                if (my_referencePressures[i] > 0) {
                    points2.push({f: my_referenceFlows[i], p: my_referencePressures[i]});
                }
            }

            d3RootG.append("path")
                .attr("class", "sound-level-line myLine")
                .attr("d", lineFunc(points2));


            d3RootG.append('circle')
                .attr('cx', d3ScaleX(requestedQ))
                .attr('cy', d3ScaleY(requestedPtot))
                .attr('r', 4)
                .attr('stroke-width', 2)
                .attr('stroke', 'blue')
                .attr('fill', 'none');

            //const projectedQ = 0.15;


            //axisYG
            //.selectAll("text").attr("y", -5).attr("x", 7)
            //.attr("dy", ".35em")
            //.attr("transform", "rotate(90)")
            //.style("text-anchor", "end");

            // const d3ScaleY = d3.scaleLinear().range([0 ,chartDataAreaWidth]).domain([minFlowValue, maxFlowValue]);
            // d3RootG.append("g")
            //     .attr("class", "axis axis--x")
            //     //.attr("transform", "translate(0," + height + ")")
            //     .call(d3.axisBottom(d3ScaleX).ticks(15))
            //     .selectAll("text")
            //     .attr("y", -5)
            //     .attr("x", 7)
            //     //.attr("dy", ".35em")
            //     .attr("transform", "rotate(90)")
            //     .style("text-anchor", "start");


            /*
                        const x = d3
                            .scaleLinear()
                            .domain(data.map((d) => d.year))
                            .rangeRound([margin.left, width - margin.right])
                            .padding(0.5);

                        const y1 = d3
                            .scaleLinear()
                            .domain([0, d3.max(data, (d) => d.sales)])
                            .rangeRound([height - margin.bottom, margin.top]);

                        const xAxis = (g) =>
                            g.attr("transform", `translate(0,${height - margin.bottom})`).call(
                                d3
                                    .axisBottom(x)
                                    .tickValues(
                                        d3
                                            .ticks(...d3.extent(x.domain()), width / 40)
                                            .filter((v) => x(v) !== undefined)
                                    )
                                    .tickSizeOuter(0)
                            );

                        const y1Axis = (g) =>
                            g
                                .attr("transform", `translate(${margin.left},0)`)
                                .style("color", "steelblue")
                                .call(d3.axisLeft(y1).ticks(null, "s"))
                                .call((g) => g.select(".domain").remove())
                                .call((g) =>
                                    g
                                        .append("text")
                                        .attr("x", -margin.left)
                                        .attr("y", 10)
                                        .attr("fill", "currentColor")
                                        .attr("text-anchor", "start")
                                        .text(data.y1)
                                );

                        svg.select(".x-axis").call(xAxis);
                        svg.select(".y-axis").call(y1Axis);

                        svg
                            .select(".plot-area")
                            .attr("fill", "steelblue")
                            .selectAll(".bar")
                            .data(data)
                            .join("rect")
                            .attr("class", "bar")
                            .attr("x", (d) => x(d.year))
                            .attr("width", x.bandwidth())
                            .attr("y", (d) => y1(d.sales))
                            .attr("height", (d) => y1(0) - y1(d.sales));
            */
            svg.selectAll("text")
                .attr("font-family", "Poppins");

        },
        [flowLines, referenceFlows, referencePressures, my_referenceFlows, my_referencePressures]
    );

    // TODO, key={Math.random()} is an extreme trick to re-render the chart
    return <>
        <h2>Chart showcase</h2>
        <div>
            My RPM: {myRpm}, My diameter: {myDiameter}<br/>
            <Button onClick={() => setMyRpm(myRpm / 1.02)}>RPM -</Button><Button onClick={() => setMyRpm(myRpm * 1.02)}>RPM +</Button>
            <br/>
            <Button onClick={() => setMyDiameter(myDiameter / 1.02)}>D -</Button><Button onClick={() => setMyDiameter(myDiameter * 1.02)}>D +</Button>
        </div>
        <svg
            key={Math.random()}
            ref={ref}
            viewBox={"-40 -40 1080 680"}
            style={{
                width: "100%",
                marginRight: "0px",
                marginLeft: "0px",
                backgroundColor: "#fafafa"
            }}>
        </svg>

    </>
}

FanChartShowcasePage.propTypes = {}

FanChartShowcasePage.defaultProps = {}
